<template>
  <DataTable
    url="projects"
    edit-url="edit-project-form"
    download-report="true"
  />
</template>
<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/DataTable.vue";
export default {
  name: "template-index",
  emits: ["setBreadcrumb"],
  components: { DataTable },
  data() {
    return {
      breadcrumb: [{ text: "Proyectos", link: { name: "projects" } }],
    };
  },
  created() {
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
};
</script>
